export const validatePdfFile = async (blob: Blob): Promise<void> => {
  const header = await blob.slice(0, 5).arrayBuffer();
  const headerBytes = new Uint8Array(header);

  const pdfSignature = [0x25, 0x50, 0x44, 0x46, 0x2d];

  const isValidPdf = pdfSignature.every(
    (byte, index) => headerBytes[index] === byte,
  );

  if (!isValidPdf) {
    const headerString = String.fromCharCode(...headerBytes);
    throw new Error(
      `Invalid file type: incorrect header bytes. ` +
        `Expected %PDF but got "${headerString}". `,
    );
  }
};
